import { Helmet } from 'react-helmet';
import { getSourcePropsByWidth } from '../../components/responsive-image/response-image-utils';
import { getCanonicalUrl } from '../../pages/utils/canonical-url';
import type { Product } from '../../bff-api/products/model';

export const OpenGraph = ({ product }: { product?: Product }) => {
    if (product) {
        const { c_pageURL, c_canonicalProductId, c_imageUrl } = product;
        const canonicalUrl = getCanonicalUrl({ c_pageURL, c_canonicalProductId });
        return (
            <Helmet>
                {c_imageUrl ? (
                    <meta
                        property="og:image"
                        content={getSourcePropsByWidth(c_imageUrl).defaultSrc}
                    />
                ) : null}
                <meta property="og:url" content={canonicalUrl} />
                <meta property="og:title" content={product.name} />
                <meta
                    property="og:description"
                    content={product.shortDescription ?? product.longDescription}
                />
                <meta property="og:type" content="product" />
                <meta property="og:site_name" content="Sur La Table" />
                <meta property="og:price:currency" content="USD" />
            </Helmet>
        );
    }

    return null;
};
